import {EntityType} from "@ots-frontend/ots-data";
import {BaseSelect, BaseSelectProps} from "../../base-select";
import {useMemo} from "react";
import {getEntityTypeDisplayValueAsString} from "../../../../util/entity-ui-util";
import {useTranslation} from "react-i18next";
import {SelectItem} from "@mantine/core";

type _SelectableEntityType = Extract<
  EntityType,
  | "REGION"
  | "SITE"
  | "CONTAINER"
  | "WELL"
  | "ROUTE"
  | "ROUTEGROUP"
  | "WATERTYPE"
  | "SERVICETYPE"
  | "RIG"
  | "COMPANY"
  | "WELLSTAGE"
  | "CONCOMMIGLED"
  | "PIPE"
  | "METER"
  | "SERVICETYPERULE"
  | "OPERATINGAREA"
  | "DVIR"
>;
export const ALL_SELECTABLE_ENTITY_TYPES: _SelectableEntityType[] = [
  "REGION",
  "SITE",
  "CONTAINER",
  "WELL",
  "ROUTE",
  "ROUTEGROUP",
  "WATERTYPE",
  "SERVICETYPE",
  "RIG",
  "COMPANY",
  "WELLSTAGE",
  "CONCOMMIGLED",
  "PIPE",
  "METER",
  "SERVICETYPERULE",
  "OPERATINGAREA",
  "DVIR",
];

export type SelectableEntityTypeTuple = typeof ALL_SELECTABLE_ENTITY_TYPES;
export type SelectableEntityType = SelectableEntityTypeTuple[number];

export const isSelectableEntityType = (
  value: string
): value is SelectableEntityType => {
  return ALL_SELECTABLE_ENTITY_TYPES.map((e) => e as string).includes(value);
};

export type EntityTypeSelectProps = Omit<BaseSelectProps, "defaultValue" | "data"> & {
  options?: string[] | SelectableEntityType[];
  defaultValue?: SelectableEntityType;
};

export const EntityTypeSelect = (props: EntityTypeSelectProps) => {
  const {
    options = ALL_SELECTABLE_ENTITY_TYPES,
    defaultValue,
    ...rest
  } = props;

  const {t} = useTranslation("common")

  const data = useMemo(() => {
    const items: SelectItem[] = []

    options.forEach((opt) => {
      if (isSelectableEntityType(opt)) {
        items.push({
          value: opt,
          label: getEntityTypeDisplayValueAsString(opt, t)
        })
      }
    })

    return items.sort((a, b) => a.label.localeCompare(b.label))
  }, [options, t]);

  return (
    <BaseSelect
      data={data}
      {...rest} />
  );
};
